import { DEMO_BBOX_WFS } from '../config/map.js';

const WFS_BASE = 'https://service.pdok.nl/rvo';
const PAGE_SIZE = 1000;

async function fetchWFS(servicePath, typeName, bbox = DEMO_BBOX_WFS) {
  const features = [];
  let startIndex = 0;

  // First get total count via resultType=hits
  const hitsParams = new URLSearchParams({
    service: 'WFS',
    version: '2.0.0',
    request: 'GetFeature',
    typeName,
    resultType: 'hits',
    bbox,
  });

  const hitsResponse = await fetch(`${WFS_BASE}/${servicePath}?${hitsParams}`);
  if (!hitsResponse.ok) {
    throw new Error(`WFS hits request failed: ${hitsResponse.status}`);
  }
  const hitsText = await hitsResponse.text();
  const matchCount = parseInt(hitsText.match(/numberMatched="(\d+)"/)?.[1] || '0', 10);

  console.log(`WFS ${typeName}: ${matchCount} features totaal`);

  while (startIndex < matchCount) {
    const params = new URLSearchParams({
      service: 'WFS',
      version: '2.0.0',
      request: 'GetFeature',
      typeName,
      outputFormat: 'application/json',
      srsName: 'EPSG:4326',
      bbox,
      count: PAGE_SIZE.toString(),
      startIndex: startIndex.toString(),
    });

    const url = `${WFS_BASE}/${servicePath}?${params}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`WFS request failed: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    if (data.features && data.features.length > 0) {
      features.push(...data.features);
      startIndex += data.features.length;
    } else {
      break;
    }
  }

  return {
    type: 'FeatureCollection',
    features,
  };
}

export async function fetchBRPParcels() {
  return fetchWFS(
    'brpgewaspercelen/wfs/v1_0',
    'brpgewaspercelen:BrpGewas'
  );
}

export async function fetchNatura2000() {
  return fetchWFS(
    'natura2000/wfs/v1_0',
    'natura2000:natura2000'
  );
}
